<template>
  <div class="Login">
    <div class="header">
    <!-- <div class="header" v-if="!$store.state.mediaPhone"> -->
      <link_wp :link="topLink[0]" :isBefore="1" ></link_wp>
      <link_wp :link="topLink[1]" @click.native="logout"></link_wp>
    </div>
    <div class="form">
      <logo :logo="logo"></logo>
      <div class="title fs18">{{title}}</div>
      <my_input v-for="f in forms" :key="f.label" :type="f.type" :placeholder="f.placeholder" v-model="fm[f.label]" :error="error[f.label]"></my_input>
      <div class="tips">
      </div>
      <span :title="checkCertify()?'':'请先填写表单'"><my_button class="btn" :value="state" @click.native="submit" :disable="!checkCertify()"></my_button></span>
    </div>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue';
 import MyLink from '@/components/Link.vue';
 import LinkWP from '@/components/LinkWithPseudo.vue';
 import MyInput from '@/components/Input.vue';
 import MyButton from '@/components/Button.vue';
 
 export default {
   name: 'Certification',
   data () {
     return {
       fm: {
         realname: '',
         organization: '',
       },
       error: {
         realname: '',
         organization: '',
       },
       state: '确认修改',
       reseting: false
     }
   },
   watch: {
     user () {
       console.log('watch user')
       if(!this.user)
         {
           this.$router.push({name:'frontpage'})
         }
     },
     fm: {
       handler () {
         this.state = '确认修改'
         if(!this.reseting)
           this.resetError()
       },
       deep: true
     }
   },
   methods: {
     logout() {
       this.$http.post('/api/login/logout')
           .then(res => {
             this.$store.commit("LOGOUT");
           })
     },
     resetError() {
       this.error = {
         realname: '',
         organization: '',
       }
     },
     checkCertify() {
       if(this.fm.realname || this.fm.organization)
         {
               return true
         }
       return false
     },
     submit() {
       this.state='修改中'
       let data = new FormData();
       data.set('realname', this.fm.realname)
       data.set('organization', this.fm.organization)
       this.$http.post('/api/user/update_info', data)
           .then(res => {
             console.log(res)
             this.state='修改成功'
             let that = this
             this.$store.commit('SET_USER', res.data)
             setTimeout(function() {
               that.$router.push({name: 'User'})
             }, 1000)
           })
           .catch(e => {
             let error = e.response.data.errors
             this.reseting = true;
             for(let e in error)
               {
                 this.fm[e] = ''
                 this.error[e] = error[e]
               }
             this.$nextTick(()=>{
               this.reseting = false
             })
           })
     }
   },
   computed: {
     user () {
       return this.$store.state.auth.user
     },
     topLink () {
       return this.$store.state.account.modifyInfo.links
     },
     logo(){
       return this.$store.state.logo.mainBlack
     },
     title () {
       return '修改信息'
     },
     forms () {
       return this.$store.state.account.modifyInfo.forms
     },
   },
   mounted (){
     if(!this.user)
       {
         this.$router.push({name:'frontpage'})
       }
   },
   components: {
     my_input: MyInput,
     my_button: MyButton,
     my_link: MyLink,
     link_wp: LinkWP,
     logo: Logo
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Login{
   text-align: center;
   width: 32.08vw;
   height:34.0625vw;
   background-color: white;

   box-sizing: border-box;
   padding-top: 1.32vw;
   padding-bottom: 1.2vw;
   padding-left: 3.18vw;
   padding-right: 3.18vw;

   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
 .header{
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 1.5vw;
 }
 .form {
 }
 .btn{
   margin-top: 0.99vw;
 }
 .title{
   color: #333333;
   margin-bottom: 8.82vw;
   margin-top: 1.875vw;
 }
 .tips{
   margin-top: 1.3vw;
   display: flex;
   justify-content: center;
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .Login{
     width: 100vw;
     height: 100%;
     align-items:center;
     justify-content: center;
   }
   .form{
     height: 60%;
     width: 80%;
   }
   .title{
    margin-bottom: 6vh;
   }
  .btn{
   margin-top: 6vw;
    font-size: 12px;
 }

.sendCode {
   bottom: auto;
  top: calc(74px + 6vh);
 }
 .header{
   width: 95vw;
   position: fixed;
   top: 1vw;
 }

 }

</style>
